import { useHistory, useLocation } from 'react-router';
import { useCallback } from 'react';

import { createInterpolatedTranslationKey, useTranslate } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../../../translations';

import {
   getAppointmentConfirmationStatusFilterCount,
   getAppointmentConfirmationStatusFilterSearchParamValue,
} from './AppointmentConfirmationStatusField.utils';
import { appointmentConfirmationStatusFilterStorage } from './AppointmentConfirmationStatusField.storage';
import { AppointmentConfirmationStatus } from './AppointmentConfirmationStatusField.types';

export const useAppointmentConfirmationStatusTriggerLabelExtractor = (): ((
   currentConfirmationStatuses: AppointmentConfirmationStatus[]
) => string) => {
   const translate = useTranslate();

   return (currentConfirmationStatuses) => {
      if (!currentConfirmationStatuses.length) {
         return translate(appointmentsTranslationKeys.appointmentConfirmationStatusFilter.selectConfirmationStatuses);
      }
      return translate(
         createInterpolatedTranslationKey(appointmentsTranslationKeys.appointmentConfirmationStatusFilter.chosenOf, {
            count: currentConfirmationStatuses.length,
            totalCount: getAppointmentConfirmationStatusFilterCount(),
         })
      );
   };
};

export const useAppointmentConfirmationStatusFilterSearchParamHandler = (
   currentAppointmentConfirmationStatus: AppointmentConfirmationStatus[]
): VoidFunction => {
   const history = useHistory();
   const location = useLocation();

   return useCallback(() => {
      const searchParams = new URLSearchParams(location.search);
      const appointmentConfirmationStatusFilterValue = getAppointmentConfirmationStatusFilterSearchParamValue(
         currentAppointmentConfirmationStatus
      );

      if (currentAppointmentConfirmationStatus.length) {
         searchParams.set(
            visitPaths.APPOINTMENT_CONFIRMATION_STATUS_SEARCH_PARAM,
            appointmentConfirmationStatusFilterValue
         );
         appointmentConfirmationStatusFilterStorage.setFilter(appointmentConfirmationStatusFilterValue);
      }

      if (!currentAppointmentConfirmationStatus.length) {
         searchParams.delete(visitPaths.APPOINTMENT_CONFIRMATION_STATUS_SEARCH_PARAM);
         appointmentConfirmationStatusFilterStorage.deleteFilter();
      }

      return history.replace({ search: searchParams.toString(), state: location.state });
   }, [currentAppointmentConfirmationStatus, history, location.search, location.state]);
};
